export default __webpack_public_path__ + "static/media/BackArrow.53317957.svg";